import { Component, OnInit } from '@angular/core';
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { HttpClient } from '@angular/common/http';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css']
})
export class OrganizationComponent implements OnInit {

  OrganizationModel={
    OrganizationName:'',
    Mobile:'',
    Phone:'',
    Address1:'',
    Address2:'',
    CountryID:0,
    StateID:0,
    City:'',
    ZipCode:'',
    BaseCurrencyID:0,
    PartnerDiscountPer:0,
    AffilateEarningPer:0,
    AffiliateLink:'',
    LogoPath:'',

  } 
  CountryList: any;
  StateList: any;
  CurrencyList: any;
  selectedLogo: any; 
  Submitted:any;

  constructor(private MasterService: SuperadminService, private LookupService: LookupService,public globalHelper: GlobalHelper,private spinnerService: Ng4LoadingSpinnerService) {

   }



  GetOrganizationDetails() {
    this.spinnerService.show();
    this.MasterService.GetOrganizationDetails().subscribe((data: any) => {
      this.OrganizationModel = data.OrganizationDetails;
      this.GetBindOrganizationState(this.OrganizationModel.CountryID); 
      this.GetCurrency(this.OrganizationModel.CountryID);    
      this.spinnerService.hide();
    });

  }

  
  SaveOrganizationDetails(valid) {
    this.Submitted=true;
    if(valid){
      this.Submitted=false;
   this.spinnerService.show();
    this.MasterService.SaveOrganizationDetails(JSON.stringify(this.OrganizationModel), this.selectedLogo).subscribe((data: any) => {
      this.GetOrganizationDetails();
      this.spinnerService.hide();
      
    });
  }

  }

  // Upload Image

  onUploadLogo(event: any) {
    this.selectedLogo = event.target.files[0];
  }


 

  // Init and Lookup

  ngOnInit() {
    this.GetBindCountry();
    this.GetOrganizationDetails();
  }

  GetBindCountry() {

    this.LookupService.GetLookupsList('Country', '').subscribe((data: any) => {
      this.CountryList = data.LookupItems;
    });

  }

  GetBindOrganizationState(CountryID: any) {
    let Itembo = {
      'ItemId': CountryID
    }
    this.LookupService.GetLookupsList('State', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.StateList = data.LookupItems;
    });

  }

  GetCurrency(CountryID: any) {
    let Itembo = {
      'ItemId': CountryID
    }
    this.LookupService.GetLookupsList('Currency', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.CurrencyList = data.LookupItems;
    });

  }
 


}
